var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPasswordOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_920_5495)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_920_5495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 15.9C14.154 15.9 15.9001 14.1539 15.9001 12C15.9001 9.84609 14.154 8.1 12.0001 8.1C9.84619 8.1 8.1001 9.84609 8.1001 12C8.1001 14.1539 9.84619 15.9 12.0001 15.9Z",
    stroke: "#B7B7B7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58008 12C1.58008 12 4.64008 18.71 12.0001 18.71C19.3601 18.71 22.4201 12 22.4201 12C22.4201 12 18.6901 5.29 12.0001 5.29C5.31008 5.29 1.58008 12 1.58008 12Z",
    stroke: "#B7B7B7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_920_5495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_920_5495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordOn);
export default __webpack_public_path__ + "static/media/icon_password_on.80453393c26cd79d56b180a2d4dc2214.svg";
export { ForwardRef as ReactComponent };